import React from 'react'
import AOS from 'aos'
import Heart from './heart.png';


const HeartAnimation = () => {
    AOS.init();

    return (
        <div className="containerAnimation">
            <img id="heart" className="heart"  alt="heart" src={Heart}></img>
            
            <div className = "binaryLines">
                
                <div data-aos="anim1"  data-aos-anchor=".aboutContent"  data-aos-anchor-placement="top-bottom">
                    <code>01101000011010010111000001101000011011110111000000001010</code>
                </div>
                <div data-aos="anim2"  data-aos-anchor=".aboutContent"  data-aos-anchor-placement="top-bottom">
                    <code>01101000011010010111000001101000011011110111000000001010</code>
                </div>

            </div>
        </div>
    )
}

export default HeartAnimation
